import React from "react";
import {Link} from "react-router-dom";

const Error403 = () => {
  return (
    <div className="authincation">
      <div className="container">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-5">
            <div className="form-input-content text-center error-page">
              <h1 className="error-text  font-weight-bold">403</h1>
              <h4>
                <i className="fa fa-times-circle text-danger" /> Accès interdit
              </h4>

              <p>
                Vous ne disposez pas des droits nécessaires pour accéder à cette
                ressource.
              </p>

              <div>
                <Link className="btn btn-primary" to="/">
                  Retour à l’accueil
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error403;
